"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const cache = __importStar(require("./cache"));
const styles = __importStar(require("./styles"));
var box_1 = require("./box");
exports.default = box_1.default;
var split_props_1 = require("./utils/split-props");
exports.splitProps = split_props_1.default;
var split_box_props_1 = require("./utils/split-box-props");
exports.splitBoxProps = split_box_props_1.default;
var index_1 = require("./enhancers/index");
exports.background = index_1.background;
exports.borderRadius = index_1.borderRadius;
exports.borders = index_1.borders;
exports.boxShadow = index_1.boxShadow;
exports.dimensions = index_1.dimensions;
exports.flex = index_1.flex;
exports.interaction = index_1.interaction;
exports.layout = index_1.layout;
exports.list = index_1.list;
exports.opacity = index_1.opacity;
exports.overflow = index_1.overflow;
exports.position = index_1.position;
exports.spacing = index_1.spacing;
exports.text = index_1.text;
exports.transform = index_1.transform;
exports.propTypes = index_1.propTypes;
exports.propNames = index_1.propNames;
exports.propAliases = index_1.propAliases;
exports.propEnhancers = index_1.propEnhancers;
exports.hydrate = cache.hydrate;
function extractStyles() {
    const output = {
        cache: cache.entries(),
        styles: styles.getAll()
    };
    clearStyles();
    return output;
}
exports.extractStyles = extractStyles;
function clearStyles() {
    cache.clear();
    styles.clear();
}
exports.clearStyles = clearStyles;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLCtDQUFnQztBQUNoQyxpREFBa0M7QUFFbEMsNkJBQTZCO0FBQXJCLHdCQUFBLE9BQU8sQ0FBQTtBQUNmLG1EQUF5RDtBQUFqRCxtQ0FBQSxPQUFPLENBQWM7QUFDN0IsMkRBQWdFO0FBQXhELDBDQUFBLE9BQU8sQ0FBaUI7QUFFaEMsMkNBb0IwQjtBQW5CeEIsNkJBQUEsVUFBVSxDQUFBO0FBQ1YsK0JBQUEsWUFBWSxDQUFBO0FBQ1osMEJBQUEsT0FBTyxDQUFBO0FBQ1AsNEJBQUEsU0FBUyxDQUFBO0FBQ1QsNkJBQUEsVUFBVSxDQUFBO0FBQ1YsdUJBQUEsSUFBSSxDQUFBO0FBQ0osOEJBQUEsV0FBVyxDQUFBO0FBQ1gseUJBQUEsTUFBTSxDQUFBO0FBQ04sdUJBQUEsSUFBSSxDQUFBO0FBQ0osMEJBQUEsT0FBTyxDQUFBO0FBQ1AsMkJBQUEsUUFBUSxDQUFBO0FBQ1IsMkJBQUEsUUFBUSxDQUFBO0FBQ1IsMEJBQUEsT0FBTyxDQUFBO0FBQ1AsdUJBQUEsSUFBSSxDQUFBO0FBQ0osNEJBQUEsU0FBUyxDQUFBO0FBQ1QsNEJBQUEsU0FBUyxDQUFBO0FBQ1QsNEJBQUEsU0FBUyxDQUFBO0FBQ1QsOEJBQUEsV0FBVyxDQUFBO0FBQ1gsZ0NBQUEsYUFBYSxDQUFBO0FBR0YsUUFBQSxPQUFPLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQTtBQUVwQyxTQUFnQixhQUFhO0lBQzNCLE1BQU0sTUFBTSxHQUFHO1FBQ2IsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLEVBQUU7UUFDdEIsTUFBTSxFQUFFLE1BQU0sQ0FBQyxNQUFNLEVBQUU7S0FDeEIsQ0FBQTtJQUNELFdBQVcsRUFBRSxDQUFBO0lBQ2IsT0FBTyxNQUFNLENBQUE7QUFDZixDQUFDO0FBUEQsc0NBT0M7QUFFRCxTQUFnQixXQUFXO0lBQ3pCLEtBQUssQ0FBQyxLQUFLLEVBQUUsQ0FBQTtJQUNiLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQTtBQUNoQixDQUFDO0FBSEQsa0NBR0MifQ==